export { default } from "./Page"
